// l10n status: partial
//import { Grid } from "@mui/material"
import { CreateComponent } from "components/utils/CreateComponent"
import { useRef, useState, useEffect, useLayoutEffect, memo } from "react"
import { rootStore } from "store/RootStore"
import { HeroTile } from "./HeroTile"
import { GenreTile } from "./GenreTile"
import { PersonTile } from "./PersonTile"
import { CategoryButton } from "./CategoryButtons"
import { CALLING_CONTEXT_TYPE } from "store/page/OverlayEventDetails"
import { PROGRAM_ORIGIN } from "scenes/components/EpgChannelDetailsInfo"
import Velocity from "velocity-animate"
import "velocity-animate/velocity.ui.min.js"
import { throttle, debounce } from "lodash"
//import { useInView } from "react-intersection-observer"
import { useMediaQuery } from "hooks/useMediaQyery"
import { isIpad, isAndroid } from "utils/Utils"
import { DiscoverConst } from "./DiscoverConst"
import { l10n } from "store/lang/L10n"

import "./../Overlay/OverlayEventDetails.css"

export const DiscoverCarousel = CreateComponent(null, false, true, ({ variant, page, lane, contentArray, oEventData, origin = PROGRAM_ORIGIN.discover, hasLiveTile = false, callingContext = CALLING_CONTEXT_TYPE.keepOldContext, resetOverlay = () => { }, clickHandler = () => { } }) => {
	//console.debug("DiscoverCarousel", variant, lane, contentArray, page, oEventData, origin, callingContext)
	//console.debug("DiscoverCarousel", variant, origin, callingContext)
	//const [contentArray, setContentArray] = useState([])
	let isMobile = useMediaQuery(`(max-width: ${DiscoverConst.mobileBreak}px)`)
	let isMedium = useMediaQuery(`(min-width: ${DiscoverConst.mobileBreak + 1}px) and (max-width: ${DiscoverConst.mediumBreak}px)`)
	const isTablet = isIpad() || isAndroid()

	const [scrollArrow, setScrollArrows] = useState({
		leftArrow: false,
		rightArrow: false,
		leftShader: false,
		rightShader: false
	})

	const [mouseDown, setMouseDown] = useState(false)
	const [isDragging, setIsDragging] = useState(false)
	const [innerWidth, setInnerWidth] = useState(window.innerWidth)
	const [innerHeight, setInnerHeight] = useState(window.innerHeight)
	const [containerWidth, setContainerWidth] = useState(window.innerWidth)
	// MTVW-931, finding 1: add visibility for episode tiles
	// MTVW-947: performance, disabled
	//const [episodesVisible, setEpisodesVisible] = useState(false)
	let dragDistance = 0

	//const [ref, inView, entry] = useInView({ rootMargin: "0px 0px 0px 0px" /*, root: document.querySelector(".seriesEpisodeGrid")*/ })
	/*
	if (inView) {
		console.debug("DiscoverCarousel inView %s %o %o", entry?.isIntersecting, entry?.target, entry)
	}
	*/

	const refContentContainer = useRef(null)

	function scrollStep(direction) {
		const orgDirection = direction
		if (!direction) direction = 1 // during velocity animation
		const tileDistance = forwardRef?.current?.tileWidth ? Math.round(forwardRef?.current?.tileWidth + tileGap) : undefined
		const currentLeft = refContentContainer?.current?.scrollLeft ? Math.round(refContentContainer?.current?.scrollLeft) : 0
		const step = tileDistance
		const offset = step ? Math.abs(Math.round(currentLeft % step - step)) % step : 0
		// undefined tileDistance case is handled here
		const adjustedStep = step + direction * offset > tileDistance ? step + direction * offset - tileDistance : step + direction * offset
		// TODO: why is this called during velocityAnimation?
		//if (variant === "hero") console.debug("scrollStep dir %s, orgDir %s, offset %s, scrollLeft %s, step %s, adjStep %s ", direction, orgDirection, offset, currentLeft, step + direction * offset, adjustedStep)
		const result = adjustedStep > 0 ? adjustedStep : refContentContainer?.current ? refContentContainer?.current?.clientWidth / 2 : 200
		//console.debug("scrollStep", result)
		return result
		//return forwardRef?.current?.tileWidth ? forwardRef?.current?.tileWidth + tileGap : refContentContainer?.current ? refContentContainer?.current?.clientWidth / 2 : 200
	}
	function scrollIndex() {
		const tileDistance = forwardRef?.current?.tileWidth ? Math.round(forwardRef?.current?.tileWidth + tileGap) : undefined
		return refContentContainer?.current?.scrollLeft ? tileDistance ? Math.round(refContentContainer.current.scrollLeft / tileDistance) : 0 : 0
		//return refContentContainer?.current?.scrollLeft ? Math.round(refContentContainer.current.scrollLeft / scrollStep()) : 0
	}

	const [isAnimating, setIsAnimating] = useState(false)
	function animationCompleted() {
		setIsAnimating(false)
	}
	//const easingOption = [.17, .67, .83, .67]
	const easingOption = [0, 0.75, 0, 1]
	function velocityAnimation(elem, left, duration, onComplete = null) {
		//console.debug("velocityAnimation elem %o, left %o, duration %o, onComplete %o", elem, left, duration, onComplete)
		setIsAnimating(true)
		Velocity(elem, { scrollLeft: left + "px" }, {
			duration: duration,
			easing: easingOption,
			complete: function (val) {
				if (onComplete) onComplete()
			}
		})
	}

	function updateScrollArrowState(ref) {
		if (ref?.current) {
			const scrollWidth = ref?.current?.scrollWidth
			//console.debug("variant", variant, lane, contentArray.length, scrollWidth, ref?.current?.clientWidth, ref?.current)
			const maxScrollLeft = Math.floor(ref?.current?.scrollWidth - ref?.current?.clientWidth) - 5
			//console.debug("maxScrollLeft", maxScrollLeft, ref?.current?.scrollLeft)
			// do not compare to 0 because of floating point numbers
			if (ref?.current?.scrollLeft < 5) {
				refContentContainer.current.scrollLeft = 0
				let rightArrow = false
				let rightShader = false
				if (scrollWidth > ref?.current?.clientWidth) {
					rightArrow = !isTablet && !isMobile
					rightShader = true
				}
				setScrollArrows({ leftArrow: false, rightArrow: rightArrow, leftShader: false, rightShader: rightShader })
			} else if (ref?.current?.scrollLeft > maxScrollLeft) {
				setScrollArrows({ leftArrow: !isTablet && !isMobile, rightArrow: false, leftShader: true, rightShader: false })
			} else {
				setScrollArrows({ leftArrow: !isTablet && !isMobile, rightArrow: !isTablet && !isMobile, leftShader: true, rightShader: true })
			}
		}
	}

	const velocityThrottled = throttle(velocityAnimation)
	function handleKeyDown(event) {
		//console.debug("DiscoverCarousel handleKeyDown", refContentContainer?.current.scrollLeft, event)
		if (refContentContainer?.current) {
			if (event.keyCode === 39) {
				//console.debug("right", scrollStep(), refContentContainer?.current?.clientWidth)
				event.preventDefault()
				event.stopPropagation()
				const targetPos = refContentContainer.current.scrollLeft + scrollStep(1)
				velocityThrottled(refContentContainer.current, targetPos, 300, animationCompleted)
			}
			if (event.keyCode === 37) {
				//console.debug("left", scrollStep(), refContentContainer?.current?.clientWidth)
				event.preventDefault()
				event.stopPropagation()
				const targetPos = refContentContainer.current.scrollLeft - scrollStep(-1)
				velocityThrottled(refContentContainer.current, targetPos, 300, animationCompleted)
			}
		}
	}
	//const handleKeyDown = throttle(handleKeyDownImpl, 350)

	function handleMouseDown(event) {
		// DO NOT call preventDefault and stopPropagation, otherwise when opened from search the search input box
		// will not work, since the component might be left open and removeEventListeners are not called
		//event.preventDefault()
		//event.stopPropagation()
		setIsDragging(false)
		setMouseDown(true)
		dragDistance = 0
		const elem = document.getElementById("seriesEpisodeContainer")
		if (elem) elem.style.scrollSnapType = "none"
	}

	function handleMouseMove(event) {
		//event.preventDefault()
		//event.stopPropagation()
		//refContentContainer?.current?.focus()
		// MTVW-947: performance, moved into if condition below
		//setIsDragging(true)
		if (mouseDown && refContentContainer?.current) {
			if (!isDragging) setIsDragging(true)
			refContentContainer.current.scrollLeft -= event.movementX
			dragDistance += event.movementX
			//console.debug("dragDistance", dragDistance)
		}
	}

	function handleMouseUp(event) {
		//event.preventDefault()
		//event.stopPropagation()
		if (mouseDown) {
			setMouseDown(false)
			if (isDragging) {
				event?.nativeEvent?.stopImmediatePropagation()
				let targetPos = 0
				if (dragDistance !== 0) {
					targetPos = dragDistance < 0 ? refContentContainer.current.scrollLeft + scrollStep(1) : refContentContainer.current.scrollLeft - scrollStep(-1)
					velocityThrottled(refContentContainer.current, targetPos, 300, animationCompleted)
				}
				dragDistance = 0
			}
			setTimeout(() => {
				setIsDragging(false)
				const elem = document.getElementById("seriesEpisodeContainer")
				if (elem) elem.style.scrollSnapType = "x mandatory"
			}, 500)
		}
	}

	function handleResize() {
		const resizeDisabled = origin === PROGRAM_ORIGIN.discover ? rootStore.page.OverlayEventDetails.isShow || rootStore.page.Discover.isShow : false
		//console.debug("resizeDisabled", origin, resizeDisabled)
		if (resizeDisabled) return

		isMobile = window.innerWidth <= DiscoverConst.mobileBreak
		isMedium = window.innerWidth > DiscoverConst.mobileBreak && window.innerWidth <= DiscoverConst.mediumBreak
		if (refContentContainer?.current) {
			// sometime mouse drag in the hero tile will cause handleResize
			//refContentContainer.current.scrollLeft = 0
		}
		setInnerWidth(window.innerWidth)
		setInnerHeight(window.innerHeight)
		// timeout to assure proper getElementById in defineContainerWidth
		setTimeout(() => {
			defineContainerWidth()
			updateScrollArrowState(refContentContainer)
		}, 50)
		//console.debug("handleResize", window.innerWidth, window.innerHeight)
	}

	useEffect(() => {
		// set 'useCapture' to true, so that we get the event before TvGuide and can stopPropagation
		// would conflict with person carousel
		//document.addEventListener("keydown", handleKeyDown, true)
		// for PRORAM_ORIGIN.overlay resizing is done via observable rootStore.page.Discover. modalWidth / modalHeight
		// MTVW-1164: if commented, handleResize not only in discover
		/*if (origin === PROGRAM_ORIGIN.discover)*/ window.addEventListener("resize", debounce(handleResize, 100))
		//setContentArray([])
		setScrollArrows({ leftArrow: false, rightArrow: false, leftShader: false, rightShader: false })
		setTimeout(() => {
			// make sure scrollWidth is up to date and scroll arrows are properly shown
			if (refContentContainer?.current && variant === "person") refContentContainer.current.scrollLeft = 0
			updateScrollArrowState(refContentContainer)
		}, 500)
		return (() => {
			//document.removeEventListener("keydown", handleKeyDown, true)
			// MTVW-1164: if commented, handleResize not only in discover
			/*if (origin === PROGRAM_ORIGIN.discover)*/ window.removeEventListener("resize", debounce(handleResize, 100)) // when unload
		})
	}, [])

	useEffect(() => {
		handleResize()
	}, [rootStore.page.Discover.modalWidth, rootStore.page.Discover.modalHeight, rootStore.page.OverlayEventDetails.isShow, rootStore.page.Discover.isShow])

	let widthBreak = 800 // default like in EpgChannelDetailsInfo
	const arrowHalfHeight = 32 / 2
	const defaultArrowTop = innerWidth <= widthBreak && variant === "person" ? 65 - arrowHalfHeight : 85 - arrowHalfHeight
	const tileGap = 24 // .seriesEpisodeContainer.gap (24px) between tiles

	// MTVW-947: moved into function using setContainerWidth
	function defineContainerWidth() {
		// CHANGE for full width
		let cWidth = innerWidth	// for hero tile
		//if (variant === "lane") containerWidth = isMobile ? innerWidth - 16 : isMedium ? innerWidth - 40 : innerWidth - 80
		//console.debug("DiscoverCarousel origin=", origin, rootStore.page.OverlayEventDetails.isShow)
		// MTVW-931: containerWidth adjustments
		if (origin === PROGRAM_ORIGIN.discover) {
			cWidth = window.innerWidth
			if (hasLiveTile) cWidth -= rootStore.page.Discover.firstTileMarginLeft[origin] + DiscoverConst.tileWidth + DiscoverConst.tileGap + DiscoverConst.extraGap
		}
		else if (origin === PROGRAM_ORIGIN.overlay || rootStore.page.OverlayEventDetails.isShow) {
			const isMobile = window.innerWidth <= DiscoverConst.mobileBreak
			let width = document.getElementById("eventComponent")?.getBoundingClientRect()?.width
			if (!width) {
				width = document.getElementById("discoverCategoryComponent")?.getBoundingClientRect()?.width
				widthBreak = 1024
			}
			//console.debug("width=", origin, width)
			if (width) {
				cWidth = width
				rootStore.page.Discover.setFirstTileMarginLeft(isMobile ? DiscoverConst.marginOverlay : window.innerWidth > widthBreak ? DiscoverConst.marginDesktop : DiscoverConst.marginOverlay, origin)
			}
		}
		else if (origin === PROGRAM_ORIGIN.liveTv) {
			const width = document.getElementById("ql_player_container")?.getBoundingClientRect()?.width
			if (width) {
				cWidth = width
				rootStore.page.Discover.setFirstTileMarginLeft(DiscoverConst.marginLiveTv, origin)
			}
			//console.debug("width=", origin, width)
		}
		setContainerWidth(cWidth)
	}

	// MTVW-947: performance, useLayoutEffect -> useEffect
	useEffect(() => {
		defineContainerWidth()
		// MTVW-947": performance, only for "episode"
		if (variant === "episode") {
			// setTimeout to make sure DOM is updated with new containerWidth and getElementById can find the element,
			// otherwise the scrollLeft calculation will be wrong and scroll to this episode will not work
			setTimeout(() => {
				const thisEpisodeRect = document.getElementById(`thisEpisode_${origin}`)?.getBoundingClientRect()
				const episode0 = document.getElementById(`episode_${origin}_0`)
				//console.debug("thisEpisode", `thisEpisode_${origin}`, thisEpisodeRect, refContentContainer?.current?.scrollLeft, origin, episode0)
				/*
				for (var i = 0; i < contentArray.length; i++) {
					const elem = document.getElementById(`episode_${i}`)?.getBoundingClientRect()
					console.debug("ix left", i, elem?.left)
				}
				*/
				let offset = episode0?.getBoundingClientRect()?.left
				//console.debug("episode0", origin, thisEpisodeRect, episode0)
				if (!offset) offset = 0
				//console.debug("useEffect", thisEpisodeRect?.left, offset, refContentContainer?.current?.scrollLeft)
				//console.debug("innerWidth", innerWidth)
				const widthGradient = innerWidth <= widthBreak ? 0 : 0 //80
				//console.debug("debug- ref %o, this %o, e0 %o", refContentContainer?.current, thisEpisodeRect, episode0)
				if (refContentContainer?.current && thisEpisodeRect && episode0) refContentContainer.current.scrollLeft = thisEpisodeRect.left - offset - widthGradient
		}, 50)
		}
		if (refContentContainer?.current && variant === "person") refContentContainer.current.scrollLeft = 0
		updateScrollArrowState(refContentContainer)
		//console.debug("scrollLeft", refContentContainer.current.scrollLeft)
		/* MTVW-947: disabled
		setTimeout(() => {
			setEpisodesVisible(true)
		}, 50)
		*/
		// MTVW-1016: added refContentContainer.current to fix scroll to this episode
	}, [contentArray, innerWidth, innerHeight, refContentContainer.current])

	const forwardRef = useRef(null)

	//if (variant === "catButton") console.debug("isLaneOnHero", rootStore.page.Discover.isLaneOnHero[origin], page)

	return (
		<>
			{contentArray?.length >= 1 ?
				<>
					{/* replaced Grid with div */}
					{/* MTVW-931: set width and marginLeft*/}
					<div id="seriesEpisodeGrid" className="seriesEpisodeGrid" /*container*/ style={{ width: containerWidth ? containerWidth : 0, position: "relative", marginLeft: variant === "episode" || variant === "person" ? -rootStore.page.Discover.firstTileMarginLeft[origin] + "px" : "", marginRight: variant === "episode" || variant === "person" ? 0 : "" }}>
						<div ref={refContentContainer} id={origin === PROGRAM_ORIGIN.discover ? "seriesEpisodeContainer" : "seriesEpisodeContainerCategory"} /*tabindex={-1}*/ className={origin === PROGRAM_ORIGIN.discover ? "seriesEpisodeContainer" : "seriesEpisodeContainerCategory"}
							// CHANGE for full width, comment style below
							//style={{ scrollSnapType: "x mandatory", width: isMobile ? innerWidth - 40 : isMedium ? innerWidth - 120 : innerWidth - 160 }}
							style={{ scrollSnapType: "x mandatory"/*, width: containerWidth - 0*/ }}
							//onKeyDown={handleKeyDown}
							onMouseDown={handleMouseDown}
							onMouseUp={handleMouseUp}
							onMouseLeave={handleMouseUp}
							onMouseMove={handleMouseMove}
							onScroll={() => {
								updateScrollArrowState(refContentContainer)
							}}>
							{true && // inView && -> causes redraw on vertical scroll!
								<>
									{variant === "hero" && contentArray?.map((item, ix) => (
										// key would cause visual distortion when switching tabs
										//<HeroTile key={`he_T_${page.liveEvent}` + ix} variant={"episode"} isDragging={isDragging} page={page} oEventData={null} item={item} ix={ix} forwardRef={forwardRef} nbItems={contentArray.length} origin={origin} scrollIndex={scrollIndex()} isAnimating={isAnimating} />
										<HeroTile key={`he_T_$` + ix} variant={"episode"} isDragging={isDragging} page={page} oEventData={null} item={item} ix={ix} forwardRef={forwardRef} nbItems={contentArray.length} origin={origin} scrollIndex={scrollIndex()} isAnimating={isAnimating} />
									))}
									{variant === "lane" && contentArray?.map((item, ix) => (
										<GenreTile key={"ln_T" + ix} variant={"lane"} lane={lane} isDragging={isDragging} page={page} oEventData={oEventData} item={item} ix={ix} nbItems={contentArray.length} origin={origin} hasLiveTile={hasLiveTile} resetOverlay={resetOverlay} />
									))}
									{/* MTVW-931: added variant === "episode" and variant === "person" */}
									{variant === "episode" && contentArray?.map((item, ix) => (
										<GenreTile key={"ep_T" + ix} variant={"episode"} isDragging={isDragging} page={page} oEventData={oEventData} item={item} ix={ix} nbItems={contentArray.length} origin={origin} resetOverlay={resetOverlay} /* MTVW-947: commented visible={episodesVisible}*/ />
									))}
									{variant === "person" && contentArray?.map((item, ix) => (
										<PersonTile key={"pe_T" + ix} variant={"person"} isDragging={isDragging} page={page} oEventData={oEventData} item={item} ix={ix} nbItems={contentArray.length} origin={origin} />
									))}
									{variant === "catButton" && contentArray?.map((item, ix) => (
										<CategoryButton key={"ca_B" + ix} variant={"catButton"} isDragging={isDragging} page={page} oEventData={oEventData} item={item} ix={ix} nbItems={contentArray.length} origin={origin} forwardRef={forwardRef} clickHandler={clickHandler} />
									))}
								</>
							}
							{/*console.debug("forwardRef", forwardRef?.current)*/}
							{/* catButton on discover page is not on hero*/}
							{variant !== "catButton" || origin === PROGRAM_ORIGIN.discover || !rootStore.page.Discover.isLaneOnHero[origin] ?
								<div className={`edgeContainerLeft ${variant === "catButton" && !rootStore.page.Discover.isLaneOnHero[origin] ? " edgeContainerLeftCategory" : ""}`}
									style={{ /*height: 172,*/ height: "100%",
										//width: variant === "catButton" && (isMobile || isTablet) ? 0 : "",
										opacity: scrollArrow.leftShader ? 1 : 0, left: variant !== "hero" ? 0 : "",
										background: forwardRef?.current?.edgeShader === false ? "unset" : ""
									}}>
									<div className="edgeButtonContainerLeft"
										style={{
											opacity: scrollArrow.leftArrow ? 1 : 0,
											top: forwardRef?.current?.arrowTop ? forwardRef?.current?.arrowTop - arrowHalfHeight : defaultArrowTop,
											left: 24 /*left: rootStore.page.Player.isInLiveTv ? -35 : ""*/
										}}>
										{!isMobile && !isTablet &&
											<>
												<div className="edgeButtonBg" />
												<div className="edgeButtonLeftImg"
													style={{
														cursor: scrollArrow.leftArrow ? "pointer" : "default"
													}}
													onClick={(e) => {
														e.preventDefault()
														e.stopPropagation()
														if (scrollArrow.leftArrow && refContentContainer?.current) {
															const targetPos = refContentContainer.current.scrollLeft - scrollStep(-1)
															velocityThrottled(refContentContainer.current, targetPos, 300, animationCompleted)
														}
													}} />
											</>
										}
									</div>
								</div>
								:
								<>
									{/* MTVW-933, finding 4: no edge container if no leftArrow */}
									{scrollArrow.leftArrow &&
										<div className="edgeContainerLeft"
											style={{
												height: "100%",
												opacity: scrollArrow.leftShader ? 1 : 0,
												right: "",
												background: "unset"
											}}>
											{!isMobile && !isTablet &&
												<>
													<div className="edgeCircleContainer" />
													<div className="edgeButtonContainerLeft" style={{ opacity: scrollArrow.leftArrow ? 1 : 0, top: forwardRef?.current?.arrowTop ? forwardRef?.current?.arrowTop - arrowHalfHeight : defaultArrowTop, left: 24 /*left: rootStore.page.Player.isInLiveTv ? -35 : ""*/ }}>
														<div className="edgeButtonBg" />
														<div className="edgeButtonLeftImg"
															style={{
																cursor: scrollArrow.leftArrow ? "pointer" : "default"
															}}
															onClick={(e) => {
																e.preventDefault()
																e.stopPropagation()
																if (scrollArrow.leftArrow && refContentContainer?.current) {
																	const targetPos = refContentContainer.current.scrollLeft - scrollStep(-1)
																	velocityThrottled(refContentContainer.current, targetPos, 300, animationCompleted)
																}
															}} />
													</div>
												</>
											}
										</div>
									}
								</>
							}
							{/* CHANGE for full width height: "100%", visibility: scrollArrow.rightArrow ? "visible" : "hidden", background: forwardRef?.current?.edgeShader === false ? "unset" : "" }}>
							<div className="edgeButtonContainerRight" style={{ top: forwardRef?.current?.arrowTop ? forwardRef?.current?.arrowTop - arrowHalfHeight : 135 - arrowHalfHeight }}>
							*/}
							{/* catButton on discover page is not on hero*/}
							{variant !== "catButton" || origin === PROGRAM_ORIGIN.discover || !rootStore.page.Discover.isLaneOnHero[origin] ?
								<div className={`edgeContainerRight ${variant === "catButton" ? " edgeContainerRightCategory" : ""}`}
									//onClick={(e) => { console.debug("click edgeContainerRight") }}
									style={{ /*height: 172, */ height: "100%",
										//width: variant === "catButton" && (isMobile || isTablet) ? 0 : "",
										opacity: scrollArrow.rightShader ? 1 : 0,
										right: variant !== "hero" ? isMedium ? /*20 : 80*/ 0 : 0 : "",
										background: forwardRef?.current?.edgeShader === false ? "unset" : ""
									}}>
									<div className="edgeButtonContainerRight"
										style={{
											opacity: scrollArrow.rightArrow ? 1 : 0,
											top: forwardRef?.current?.arrowTop ? forwardRef?.current?.arrowTop - arrowHalfHeight : defaultArrowTop,
											left: 24
										}}>
										{!isMobile && !isTablet &&
											<>
												<div className="edgeButtonBg" />
												<div className="edgeButtonRightImg"
													style={{
														cursor: scrollArrow.rightArrow ? "pointer" : "default"
													}} onClick={(e) => {
														e.preventDefault()
														e.stopPropagation()
														if (scrollArrow.rightArrow && refContentContainer?.current) {
															const targetPos = refContentContainer.current.scrollLeft + scrollStep(1)
															velocityThrottled(refContentContainer.current, targetPos, 300, animationCompleted)
														}
													}} />
											</>
										}
									</div>
								</div>
								:
								<>
									{/* MTVW-933, finding 4: no edge container if no rightArrow */}
									{scrollArrow.rightArrow &&
										<div className="edgeContainerRight"
											style={{
												height: "100%",
												opacity: scrollArrow.rightShader ? 1 : 0,
												right: "",
												background: "unset"
											}}>
											{!isMobile && !isTablet &&
												<>
													<div className="edgeCircleContainer" />
													<div className="edgeButtonContainerRight"
														style={{
															opacity: scrollArrow.rightArrow ? 1 : 0,
															top: forwardRef?.current?.arrowTop ? forwardRef?.current?.arrowTop - arrowHalfHeight : defaultArrowTop,
															left: 24
														}}>
														<div className="edgeButtonBg" style={{ top: -2 }} />
														<div className="edgeButtonRightImg"
															style={{
																top: -2,
																cursor: scrollArrow.rightArrow ? "pointer" : "default"
															}} onClick={(e) => {
																e.preventDefault()
																e.stopPropagation()
																if (scrollArrow.rightArrow && refContentContainer?.current) {
																	const targetPos = refContentContainer.current.scrollLeft + scrollStep(1)
																	velocityThrottled(refContentContainer.current, targetPos, 300, animationCompleted)
																}
															}} />
													</div>
												</>
											}
										</div>
									}
								</>
							}
						</div>
					</div>
				</>
				: <></>
			}
		</>
	)
})
